<template>
    <component :is="componentIs">
        <slot v-bind="{ enter, loading, errorMessages }" />
    </component>
</template>

<script>
import api from "@/api";

export default {
    props: {
        code: { type: String, default: null },
        onError: { type: Function, default: () => {} },

        componentIs: { type: String, default: "div" },
    },
    data: () => ({
        loading: false,
        errorMessages: null,
    }),
    watch: {
        code() {
            this.errorMessages = null;
        },
    },
    methods: {
        async enter() {
            if (this.loading) return;
            else this.loading = true;

            try {
                await api.v1.interview.get({ code: this.code });
                location.href = `/interview/${this.code}`;
            } catch (error) {
                this.errorMessages = error.response.data.message;
                this.onError();
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
</style>